export default defineNuxtPlugin(() => {
  if (process.client) {
    document.body.addEventListener('click', (event) => {
      const target = event.target.closest('[data-attr]')
      if (target) {
        const eventName = target.getAttribute('data-attr')
        const eventProperty = target.getAttribute('data-attr-property')
        console.log(eventProperty)
        console.log(eventName)
        const { $posthogJS } = useNuxtApp()
        $posthogJS?.capture(eventName, eventProperty ? JSON.parse(eventProperty) : null)
      }
    });
  }
});
